import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LayoutLibrary } from '..'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { SizeTracker } from '../../common/SizeTracker'
import { Table } from '../../common/table'
import { selectFragment } from '../savedPortfolios/portfoliosOverview/store/slice/sliceComponent'
import { PaginationTableFollowingList } from './components/Pagination'
import { HeaderFollowingList } from './headerFollowingList'
import { Header } from './headerFollowingList/Header'
import classes from './index.module.scss'
import { getSchemaTableFollowingList } from './schemaTableFollowingList'
import {
  changeFilter,
  getDataTableFollowingListFromRedux,
  getLoadingFollowingList,
  resetStore,
  selectFilterTableFollowingList,
  selectIdsTableFollowingList,
} from './store/slice'
import {
  getAllIdFollow,
  getHeaderFollow,
  getSearchCompanyInFollowList,
} from './store/thunk'

const FollowingList = () => {
  const dispatch = useDispatch()
  const ids = useSelector(selectIdsTableFollowingList)
  const filter = useSelector(selectFilterTableFollowingList())
  const fragment = useSelector(selectFragment)
  const isLoading = useSelector(getLoadingFollowingList('table'))
  const isLoadingGetAllId = useSelector(getLoadingFollowingList('getAllId'))
  const locale = useSelector((state) => state.i18n.locale)
  const text = useSelector(selectFilterTableFollowingList('term'))

  const handleChangeSort = (sort) => {
    dispatch(
      changeFilter({
        sort: sort?.sortBy,
        sortDirection: sort?.sortDirection,
        page: 1,
      }),
    )
  }

  useEffect(() => {
    dispatch(getSearchCompanyInFollowList(filter))
  }, [JSON.stringify(filter), fragment, locale])

  useEffect(() => {
    dispatch(getHeaderFollow({}))
    return () => {
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    dispatch(
      getAllIdFollow({
        term: text,
      }),
    )
  }, [text])

  return (
    <LayoutLibrary
      renderTopComponent={() => (
        <div style={{ padding: '0 6px' }}>
          <Header />
        </div>
      )}
      renderBottomComponent={() => (
        <div className={classes.followingListMain} style={{ padding: '0 6px' }}>
          {(isLoading || isLoadingGetAllId) && <Loading />}

          <SizeTracker
            renderTopComponent={() => (
              <Element
                className={classes.header}
                style={{ borderColor: '#E5E5E8' }}
              >
                <HeaderFollowingList />
              </Element>
            )}
          >
            {(size) => {
              return (
                <div
                  style={{
                    opacity: isLoading ? 0 : 1,
                    height: `calc(100% - ${size.height}px)`,
                  }}
                >
                  <Table
                    ids={ids}
                    getDataFromRedux={getDataTableFollowingListFromRedux}
                    schema={getSchemaTableFollowingList()}
                    isNoDataWithHead
                    noDataText="library.followingList.NO_COMPANY_TEXT"
                    sort={{
                      sortBy: filter?.sort,
                      sortDirection: filter?.sortDirection,
                    }}
                    changeSort={handleChangeSort}
                    renderPagination={() => <PaginationTableFollowingList />}
                    isCenterNoData={false}
                  />
                </div>
              )
            }}
          </SizeTracker>
        </div>
      )}
    />
  )
}

export default FollowingList
